export default function focusSync(store) {
    // no need to remove this listener since we use it in a vuex store plugin and the store is loaded on every page
    // eslint-disable-next-line tipsi/remove-event-listener
    window.addEventListener('focus', () => store.commit('ui/SET_PAGE_IS_FOCUSED', true));
    // eslint-disable-next-line tipsi/remove-event-listener
    window.addEventListener('blur', () => store.commit('ui/SET_PAGE_IS_FOCUSED', false));
}
